













































































































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { tooltipTrigger } from "../../../../../../shared/utils/tooltipTrigger";
import Icon from "../../../../../Icon/Icon.vue";
import ZoomableImage from '../../../../../ZoomableImage/NewZoomableImage.vue'
import { BaseMediaFileData, CustomMediaFileData, MediaFileData } from '../../logic/MediaFileData'
import MediaManager from '../../logic/MediaManager'
import { FileType, MediaFileStatus } from '../../types'

@Component({
  methods: {
    tooltipTrigger
  },
  components: {
    Icon,
    ZoomableImage,
  },
  data() {
    return {
      MediaFileStatus,
      MediaManager,
      FileType,
      MediaFileData,
      CustomMediaFileData
    }
  }
})
export default class MediaItem extends Vue {
  @Prop() attachment!: MediaFileData | CustomMediaFileData

  @Prop({ required: true }) manager!: MediaManager

  @Prop({ type: Boolean, default: false, required: true }) isFirst!: boolean

  @Prop({ type: Boolean, default: false, required: true }) isLast!: boolean

  @Prop({ type: Boolean, required: false, default: false }) draggable!: boolean

  @Prop({ type: Boolean, required: false, default: false }) readonly!: boolean

  @Prop({ type: Boolean, required: false, default: true }) showType!: boolean

  @Emit()
  move(direction: string) {
    return direction
  }

  @Emit()
  removeAttachment(attachment: MediaFileData) {
    return attachment
  }

  iconType(attachment: MediaFileData | CustomMediaFileData) {
    return attachment instanceof CustomMediaFileData ? attachment.icon : MediaManager.getFileIcon(attachment.type)
  }

  getStrokeColor(file: MediaFileData): string {
    if (file.status === MediaFileStatus.loading) {
      if (file.progress !== 100) {
        return 'rgb(var(--a-primary))'
      }

      return 'rgb(var(--a-success))'
    }

    if (file.status === MediaFileStatus.error) {
      return 'rgb(var(--a-danger))'
    }

    return ''
  }

  setProgressStatus(status: MediaFileStatus): string | void {
    if (status === MediaFileStatus.error) {
      return 'exception'
    }
  }

  removeAttachmentHandler(attachment: MediaFileData): void {
    if (attachment.abort) {
      attachment.abort()
    }

    this.removeAttachment(attachment)
  }

  tooltipFileTypeTitle(attachment: BaseMediaFileData) {
    if (attachment instanceof CustomMediaFileData) {
      return this.$t(`file_type_to_upload_${ snakeCase(attachment.exactType) }`)
    }

    return this.$t(`file_type_to_upload_${ snakeCase(attachment.type) }`)
  }
}
